import { PlayIcon } from '@heroicons/react/24/solid';
import { t } from 'media-chrome';
import { useState } from 'react';

import { Button } from '@/components/atoms/Button';
import { HeroIcon } from '@/components/atoms/Icon';

interface Props {
  className?: string;
  onClick?: () => void;
  disabled?: boolean;
}

export function PlayAuthButton({
  className = '',
  onClick = () => {},
  disabled = false,
}: Props) {
  const [hovered, setHovered] = useState<boolean>(false);

  const handleClick = () => {
    if (disabled) {
      return;
    }
    onClick();
  };

  return (
    <div className={`relative ${className}`}>
      {hovered && !disabled && (
        <div className="absolute -top-6.5 left-1/2 -translate-x-1/2">
          <span className="bg-(--player-menu-background-default) rounded-sm px-[0.7em] py-[0.35em] font-normal text-[13px] font-(family-name:--font-sans)">
            {t('Play')}
          </span>
        </div>
      )}
      <Button
        size="sm"
        disabled={disabled}
        onMouseOver={() => !disabled && setHovered(true)}
        onMouseOut={() => setHovered(false)}
        onClick={handleClick}
        aria-label={t('Play')}
      >
        <HeroIcon icon={PlayIcon} />
      </Button>
    </div>
  );
}
